/** Extract a safe, loggable string from an unknown error.
 *  Strips the full object graph, stack trace, and internal details —
 *  only the human-readable message survives. */
export function safeError(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return 'Unknown error';
}
